/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

// required attributes
const CdiR = t.interface({
  business_name: t.string,

  id_cdi: t.string,

  psp_code: t.string
});

// optional attributes
const CdiO = t.partial({
  publication_date: UTCISODateFromString,

  validity_date: UTCISODateFromString
});

export const Cdi = t.intersection([CdiR, CdiO], "Cdi");

export type Cdi = t.TypeOf<typeof Cdi>;
